// унивресальный миксин для времени в каледндаре с недельным и видом по дням

import {mapGetters} from 'vuex';

export default {
    props: ['type'], // тип вида day или week
    computed: {
        ...mapGetters('calendar', ['day_week_header', 'date_active']),
        week_arr(){
            if (this.type == 'day') {
                // если день то занести в список только текущую дату
                let day_arr = [];

                // for(let i = 0; i < this.day_week_header.length; i++){
                    let date = this.date_active;
                    console.log(date)
                    // console.log(this.day_week_header[i])
                    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let month = (date.getMonth() + 1)  < 10 ? '0' + (date.getMonth() + 1): (date.getMonth() + 1);
                    day_arr.push(date.getFullYear() + '.' + month + '.' + day);
                // }
    
                return day_arr
            } else {
                // если неделя, то отдать список из дней недели
                let week_arr = [];
                for(let i = 0; i < this.day_week_header.length; i++){
                    let date = this.day_week_header[i].value;
                    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let month = (date.getMonth() + 1)  < 10 ? '0' + (date.getMonth() + 1): (date.getMonth() + 1);
                    week_arr.push(date.getFullYear() + '.' + month + '.' + day);
                }

                return week_arr
            }
        },
    },
    methods: {
        getIndex(date){
            // отображение в сетке недели или дня (обычно ставиться день недели но на сетке дня такого нет и возвращается 1)
            if (this.type == 'day') {
                return 1
            }
            else 
                return date.getDay() === 0 ? 7 : date.getDay();
        }
    }
}


// WEBPACK FOOTER //
// ./src/vue_components/Calendar/TimeMixin.js